import { render } from "./ModalsFaq.vue?vue&type=template&id=3acc996e"
import script from "./ModalsFaq.vue?vue&type=script&lang=js"
export * from "./ModalsFaq.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__